module.exports = __webpack_public_path__ + "static/media/japan07.3f5a8550.jpg";